import { Injectable } from '@angular/core';
import { urlServer } from '../global_constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServiceResponse } from '../models/service-response';
import { Referential } from '../models/referential';

@Injectable({
  providedIn: 'root'
})
export class ProductCategoryService {

    baseUrl=urlServer.concat("/v1/ref/categories");
    productcategoryUrl=urlServer.concat("/v1/category");
    
    public get token() : string|null {
      if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
      return localStorage.getItem("token");
      return sessionStorage.getItem("token");
    }
    
    constructor(private httpClient:HttpClient) { }
  
    getProductCategories(){
      let header: HttpHeaders = new HttpHeaders();
      header = header.set('authorization', "Bearer " + this.token);
      return this.httpClient.get<ServiceResponse>(this.baseUrl,{headers: header});
    }
  
    addProductCategory(productcategory: Referential){
      let header: HttpHeaders = new HttpHeaders();
      header = header.set('authorization', "Bearer " + this.token);
      return this.httpClient.post<ServiceResponse>(this.productcategoryUrl, productcategory, {headers: header});
    }
  
    updateProductCategory(productcategory: Referential){
      let header: HttpHeaders = new HttpHeaders();
      header = header.set('authorization', "Bearer " + this.token);
      return this.httpClient.put<ServiceResponse>(this.productcategoryUrl, productcategory, {headers: header});
    }
  
    deleteProductCategory(uuid: string){
      let header: HttpHeaders = new HttpHeaders();
      header = header.set('authorization', "Bearer " + this.token);
      return this.httpClient.delete<ServiceResponse>(`${this.productcategoryUrl}/${uuid}`,{headers: header});
    }

    checkUseProductCategory(uuid: string){
      let header: HttpHeaders = new HttpHeaders();
      header = header.set('authorization', "Bearer " + this.token);
      return this.httpClient.get<ServiceResponse>(`${this.productcategoryUrl}/${uuid}`,{headers: header});
    }
}
